/*
 * corp-motion.js - scroll reveals + stat count-ups for the corporate site.
 *
 * Layered on top of Impact's native heading apparition (split_fade). Cards,
 * rows and map pins get a one-time rise-in on first view; fact-bar numbers
 * count up from zero. Everything no-ops under prefers-reduced-motion, and
 * content is only hidden AFTER this script runs (no-JS visitors see a
 * fully static, fully visible page).
 */
(function () {
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var REVEAL_SELECTORS = [
    '.multi-column__item',
    '.blog-post-card',
    '.memento-films__card',
    '.text-with-icons__item',
    '.story-ledger__row',
    '.careers-jobs__row',
    '.hot-spot',
    '.enquiry-form__panel'
  ];

  function init() {
    document.documentElement.classList.add('corp-motion-ready');

    var els = document.querySelectorAll(REVEAL_SELECTORS.join(','));
    var byParent = new Map();
    els.forEach(function (el) {
      el.setAttribute('data-corp-reveal', el.classList.contains('hot-spot') ? 'pop' : 'rise');
      var p = el.parentElement;
      var n = byParent.get(p) || 0;
      el.style.setProperty('--corp-delay', (Math.min(n, 7) * 90) + 'ms');
      byParent.set(p, n + 1);
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('corp-inview');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -30px 0px' });
    els.forEach(function (el) { io.observe(el); });

    // ── count-up numbers ────────────────────────────────────────────────────
    function animateNumber(el) {
      var raw = el.textContent;
      var m = raw.match(/^(\s*[^\d]*)([\d][\d,]*)(.*)$/);
      if (!m) return;
      var target = parseInt(m[2].replace(/,/g, ''), 10);
      if (!isFinite(target) || target <= 0) return;
      var grouped = m[2].indexOf(',') !== -1;
      var t0 = null, DUR = 1400;
      function fmt(v) {
        v = Math.round(v);
        var s = grouped ? v.toLocaleString('en-GB') : String(v);
        return m[1] + s + m[3];
      }
      function frame(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min(1, (ts - t0) / DUR);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = fmt(target * eased);
        if (p < 1) requestAnimationFrame(frame);
        else el.textContent = raw;
      }
      el.textContent = fmt(0);
      requestAnimationFrame(frame);
    }

    var counted = new WeakSet();
    var statEls = document.querySelectorAll('.text-with-icons__item .prose > p:first-child, .storefront-card__stat-value, .article-stats__value');
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || counted.has(entry.target)) return;
        counted.add(entry.target);
        animateNumber(entry.target);
        cio.unobserve(entry.target);
      });
    }, { threshold: 0.6 });
    statEls.forEach(function (el) { cio.observe(el); });

  // ── mobile map start position ──
  // The map is wider than the phone and scrolls. Opening on the empty Pacific
  // wastes the first impression, so the map opens on the busiest stretch
  // (Europe) and the visitor swipes out from there.
  if (window.matchMedia('(max-width: 699px)').matches) {
    document.querySelectorAll('.shopify-section--hot-spots .section-stack').forEach(function (stack) {
      var overflow = stack.scrollWidth - stack.clientWidth;
      if (overflow > 40) stack.scrollLeft = Math.round(overflow * 0.46);
    });
  }


  // ── timeline auto-advance ──
  // The story/commission sliders step themselves every few seconds once
  // seen, and hand control back the moment the visitor touches them.
  document.querySelectorAll('.shopify-section').forEach(function (sec) {
    var items = sec.querySelectorAll('.timeline__nav-item');
    if (items.length < 2) return;
    var idx = 0, timer = null;
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    sec.addEventListener('pointerdown', stop, { passive: true });
    var tio = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !timer) {
          timer = setInterval(function () {
            idx = (idx + 1) % items.length;
            items[idx].click();
          }, 3400);
        } else if (!entry.isIntersecting) { stop(); }
      });
    }, { threshold: 0.4 });
    tio.observe(sec);
  });

  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
